import { IWorkspaceUser } from 'wisestep-api';
export const isBlank = (str: string | null | undefined) => (str ? !/\S/.test(str) : true);

export const extractEmail = (event: string) => {
  const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;
  const match = emailPattern.exec(event);
  if (match && match.length > 0) {
    return match[0];
  } else {
    return event;
  }
};

export const extractNameOrEmail = (formattedString: string): string => {
  const regex = /^(.*?)\s*\(([^)]+)\)$/;
  const match = formattedString.match(regex);
  if (match) {
    const name = match[1].trim();
    const email = match[2].trim();

    return name || email;
  }
  return formattedString;
};

export const getUserNameAndEmail = (user: IWorkspaceUser) => {
  let text = user?.userId;
  if (user?.userName) {
    if (user.userName?.length > 1 && user.userName?.includes('@')) {
      text = user.userName;
    } else {
      text = `${user.userName} (${user?.userId})`;
    }
  }
  return text;
};
